module.exports = __webpack_public_path__ + "img/1.edff6dc0.png";